/* eslint-disable max-len */
import { TYPES_BY_CLASS } from './constants';

export const track = (key) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.top.LIFE_CYCLE_EVENT_BUS.trigger(`fit-compatibility-drawer.${key}`);
  }
};

const validator = (str, validation) => {
  if (!str) return false;

  const lowerStr = str.toLowerCase();

  if (validation === 'washer' && lowerStr.includes('dishwasher')) {
    return false;
  }

  return lowerStr.includes(validation);
};

export const getApplianceTypeByClassNumber = (productInfo) => {
  const {
    classNumber, subClassNumber,
    productClass, productSubClass
  } = productInfo || {};
  const resolvedClass = classNumber ?? productClass ?? null;
  const resolvedSubClass = subClassNumber ?? productSubClass ?? null;
  if (!productInfo || resolvedClass === null || resolvedSubClass === null) {
    return null;
  }

  const matchedType = Object.keys(TYPES_BY_CLASS).find(
    (type) => TYPES_BY_CLASS[type].class === resolvedClass
        && TYPES_BY_CLASS[type].subclasses.includes(resolvedSubClass)
  ) ?? null;

  return matchedType;
};

export const getApplianceType = (data) => {
  const products = data?.searchModel?.products;
  if (products?.length > 1) {
    const types = new Set(products.map((product) => getApplianceTypeByClassNumber(product?.info)).filter(Boolean));
    if (types.size > 1) return null;
  }

  const productInfo = products?.[0]?.info || data?.searchModel?.info || data?.product?.info;
  const typeFromClass = getApplianceTypeByClassNumber(productInfo);
  if (typeFromClass) {
    return typeFromClass;
  }
  return null;
};

export const isBuiltInAppliance = (data) => {
  const product = data?.product;
  if (!product?.specificationGroup) return false;

  return product.specificationGroup.some((group) => group?.specifications?.some(
    (spec) => {
      return (
        spec?.specName?.toLowerCase() === 'installation type'
        && spec?.specValue?.toLowerCase() === 'built-in'
      );
    }
  )
  );
};